export let configs = {
  maintenance: false,
  theme: "dark",
  storage: "local"
};